// extracted by mini-css-extract-plugin
export default {"cart":"Emptyfav_cart__VBKD3","cart__cat":"Emptyfav_cart__cat__U2kDS"};